export default "__VITE_ASSET__BPfh3Lxv__"